const FulfilmentOptions = Object.freeze({
    POST: 0,
    IN_PERSON: 1,
    ALL: 2
})

export default FulfilmentOptions